import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const WeeklyProductsService = {
  async getAllProducts() {
    let response = await $axios
      .get($api("weekly_picks_products"))
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addProducts(payload: any) {
    try {
      const { data, status } = await $axios.post(
        $api("weekly_picks_add_products"),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
};
